// extracted by mini-css-extract-plugin
module.exports = {"infrastructure-rows":"_2787e5dfdf--infrastructure-rows--ZrqYv","non-clickable-heading-wrapper":"_2787e5dfdf--non-clickable-heading-wrapper--CJz_I"};